<template>
  <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
</template>

<script>
import MyGridLayout from "@/components/tools/MyGridLayout";
export default {
  name: "Dataset_CNV_grid",
  components: {MyGridLayout},
  data(){
    return{
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "MarkerCard", data:{datasetID: '', Array: ''} },
      ],
      index: 0,
      data: [],
      position: [],
      groundtruth_source: '',
      formData: {
        datasetID: '',
        name: ''
      },
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C','#EAAC31',
        '#EAD2AE',
        '#127678','#30B5A4','#B4D9D2',
        '#354581','#FFE074',
        '#E03C79','#88C1B8',
        '#FC6746','#F5B307','#008186'
      ],
      echart_info_cnv: {
        real: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real_umap: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real_tsne: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real1: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real1_umap: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real1_tsne: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real2: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real2_umap: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        real2_tsne: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        cnv: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        cnv_umap: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        cnv_tsne: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        copykat: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        copykat_umap: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        copykat_tsne: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
      },
    }
  },
  props:{
    sourceData: Array,
    asynGround: String,
    sourcePosition: Array,
    datasetInfo: Array
  },
  mounted() {
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.name = this.datasetInfo[0].name
    this.data = this.sourceData
    this.position = this.sourcePosition
    this.groundtruth_source= this.asynGround
    this.$nextTick(function () {
      (async()=>{
        await this.preprocess()
        this.initLayoutData()
      })();
    })
  },
  methods: {
    async preprocess(){
      let _this = this
      let haveClassification = Object.prototype.hasOwnProperty.call(_this.data[0], "Classification")
      let haveCelltype = Object.prototype.hasOwnProperty.call(_this.data[0], "celltype")
      let haveAnnot = Object.prototype.hasOwnProperty.call(_this.data[0], "annot_type")
      let haveFineAnnot = Object.prototype.hasOwnProperty.call(_this.data[0], "fine_annot_type")
      let haveInferCNV = Object.prototype.hasOwnProperty.call(_this.data[0], "inferCNV")
      let haveCopykat = Object.prototype.hasOwnProperty.call(_this.data[0], "copykat")
      let haveX = Object.prototype.hasOwnProperty.call(_this.data[0], "x")
      let haveY = Object.prototype.hasOwnProperty.call(_this.data[0], "y")
      console.log(_this.data[0])
      this.initEchartsInfo(haveClassification, haveCelltype, haveAnnot, haveFineAnnot, haveInferCNV, haveCopykat, haveX, haveY)
    },
    initEchartsInfo(haveClassification, haveCelltype, haveAnno, haveFineAnno, haveInferCNV, haveCopyKat, haveX, haveY){
      let _this = this
      // _this.data = data_json.data
      // _this.position = data_json.position
      let temp_anno;
      let temp_fine_anno;
      let temp_types_classification;
      let temp_types_inferCNV;
      let temp_types_copyKat;

      if (haveClassification || haveCelltype){
        temp_types_classification = []
        _this.echart_info_cnv.real.source.push(['type','x','y'])
        _this.echart_info_cnv.real_umap.source.push(['type','x','y'])
        _this.echart_info_cnv.real_tsne.source.push(['type','x','y'])
      }
      if (haveAnno) {
        temp_anno= []
        _this.echart_info_cnv.real1.source.push(['type','x','y'])
        _this.echart_info_cnv.real1_umap.source.push(['type','x','y'])
        _this.echart_info_cnv.real1_tsne.source.push(['type','x','y'])
      }
      if (haveFineAnno) {
        temp_fine_anno = []
        _this.echart_info_cnv.real2.source.push(['type','x','y'])
        _this.echart_info_cnv.real2_umap.source.push(['type','x','y'])
        _this.echart_info_cnv.real2_tsne.source.push(['type','x','y'])
      }
      if (haveInferCNV){
        temp_types_inferCNV = []
        _this.echart_info_cnv.cnv.source.push(['type','x','y'])
        _this.echart_info_cnv.cnv_umap.source.push(['type','x','y'])
        _this.echart_info_cnv.cnv_tsne.source.push(['type','x','y'])
      }
      if (haveCopyKat) {
        temp_types_copyKat = []
        _this.echart_info_cnv.copykat.source.push(['type','x','y'])
        _this.echart_info_cnv.copykat_umap.source.push(['type','x','y'])
        _this.echart_info_cnv.copykat_tsne.source.push(['type','x','y'])
      }
      for (let i=0; i< _this.data.length; i++) {
        if (haveClassification) {
          _this.echart_info_cnv.real_umap.source.push([_this.data[i].Classification, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.real_tsne.source.push([_this.data[i].Classification, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        }else if(haveCelltype) {
          _this.echart_info_cnv.real_umap.source.push([_this.data[i].celltype, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.real_tsne.source.push([_this.data[i].celltype, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        }
        if (haveAnno){
          _this.echart_info_cnv.real1_umap.source.push([_this.data[i].annot_type, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.real1_tsne.source.push([_this.data[i].annot_type, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        }
        if (haveFineAnno){
          _this.echart_info_cnv.real2_umap.source.push([_this.data[i].fine_annot_type, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.real2_tsne.source.push([_this.data[i].fine_annot_type, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        }
        if (haveInferCNV){
          _this.echart_info_cnv.cnv_umap.source.push([_this.data[i].inferCNV, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.cnv_tsne.source.push([_this.data[i].inferCNV, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
          if (!temp_types_inferCNV.includes(_this.data[i].inferCNV)) {
            temp_types_inferCNV.push(_this.data[i].inferCNV)
          }
        }
        if (haveCopyKat){
          _this.echart_info_cnv.copykat_umap.source.push([_this.data[i].copykat, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
          _this.echart_info_cnv.copykat_tsne.source.push([_this.data[i].copykat, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
          if (!temp_types_copyKat.includes(_this.data[i].copykat)) {
            temp_types_copyKat.push(_this.data[i].copykat)
          }
        }
      }


      if (haveClassification || haveCelltype  || haveAnno || haveFineAnno){
        if (haveX && haveY){
          for (let i=0; i< _this.data.length; i++) {
            if (haveClassification) {
              _this.echart_info_cnv.real.source.push([_this.data[i].Classification, _this.data[i].x, _this._this.data[i].y])
              if (!temp_types_classification.includes(_this.data[i].Classification)) {
                temp_types_classification.push(_this.data[i].Classification)
              }
            }else if (haveCelltype) {
              _this.echart_info_cnv.real.source.push([_this.data[i].celltype, _this.data[i].x, _this.data[i].y])
              if (!temp_types_classification.includes(_this.data[i].celltype)) {
                temp_types_classification.push(_this.data[i].celltype)
              }
            }
            if (haveAnno){
              _this.echart_info_cnv.real1.source.push([_this.data[i].annot_type, _this.data[i].x, _this.data[i].y])
              if (!temp_anno.includes(_this.data[i].annot_type)) {
                temp_anno.push(_this.data[i].annot_type)
              }
            }
            if (haveFineAnno){
              _this.echart_info_cnv.real2.source.push([_this.data[i].fine_annot_type, _this.data[i].x, _this.data[i].y])
              if (!temp_fine_anno.includes(_this.data[i].fine_annot_type)) {
                temp_fine_anno.push(_this.data[i].fine_annot_type)
              }
            }
            if (haveInferCNV){
              _this.echart_info_cnv.cnv.source.push([_this.data[i].inferCNV, _this.data[i].x, _this.data[i].y])
            }
            if (haveCopyKat){
              _this.echart_info_cnv.copykat.source.push([_this.data[i].copykat, _this.data[i].x, _this.data[i].y])
            }
          }
        }else {
          for (let i=0; i< _this.data.length; i++) {
            let index = _this.position.findIndex(item => item.spot === _this.data[i].spot)
            if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
              if (haveClassification) {
                _this.echart_info_cnv.real.source.push([_this.data[i].Classification, _this.position[index].x, _this.position[index].y])
                if (!temp_types_classification.includes(_this.data[i].Classification)) {
                  temp_types_classification.push(_this.data[i].Classification)
                }
              }else if (haveCelltype) {
                _this.echart_info_cnv.real.source.push([_this.data[i].celltype, _this.position[index].x, _this.position[index].y])
                if (!temp_types_classification.includes(_this.data[i].celltype)) {
                  temp_types_classification.push(_this.data[i].celltype)
                }
              }
              if (haveAnno){
                _this.echart_info_cnv.real1.source.push([_this.data[i].annot_type, _this.position[index].x, _this.position[index].y])
                if (!temp_anno.includes(_this.data[i].annot_type)) {
                  temp_anno.push(_this.data[i].annot_type)
                }
              }
              if (haveFineAnno){
                _this.echart_info_cnv.real2.source.push([_this.data[i].fine_annot_type, _this.position[index].x, _this.position[index].y])
                if (!temp_fine_anno.includes(_this.data[i].fine_annot_type)) {
                  temp_fine_anno.push(_this.data[i].fine_annot_type)
                }
              }
              if (haveInferCNV){
                _this.echart_info_cnv.cnv.source.push([_this.data[i].inferCNV, _this.position[index].x, _this.position[index].y])
              }
              if (haveCopyKat){
                _this.echart_info_cnv.copykat.source.push([_this.data[i].copykat, _this.position[index].x, _this.position[index].y])
              }
            }
          }
        }
      }

      if (haveClassification || haveCelltype){
        _this.echart_info_cnv.real.types = temp_types_classification
        _this.echart_info_cnv.real_umap.types = temp_types_classification
        _this.echart_info_cnv.real_tsne.types = temp_types_classification
      }
      if (haveAnno){
        _this.echart_info_cnv.real1.types = temp_anno
        _this.echart_info_cnv.real1_umap.types = temp_anno
        _this.echart_info_cnv.real1_tsne.types = temp_anno
      }
      if (haveFineAnno){
        _this.echart_info_cnv.real2.types = temp_fine_anno
        _this.echart_info_cnv.real2_umap.types = temp_fine_anno
        _this.echart_info_cnv.real2_tsne.types = temp_fine_anno
      }
      if (haveInferCNV){
        _this.echart_info_cnv.cnv.types = temp_types_inferCNV
        _this.echart_info_cnv.cnv_umap.types = temp_types_inferCNV
        _this.echart_info_cnv.cnv_tsne.types = temp_types_inferCNV
      }
      if (haveCopyKat){
        _this.echart_info_cnv.copykat.types = temp_types_copyKat
        _this.echart_info_cnv.copykat_umap.types = temp_types_copyKat
        _this.echart_info_cnv.copykat_tsne.types = temp_types_copyKat
      }

      if (_this.data.length > 5000){
        _this.echart_info_cnv.real1.spotSize = 2
        _this.echart_info_cnv.real1_umap.spotSize = 2
        _this.echart_info_cnv.real1_tsne.spotSize = 2
        _this.echart_info_cnv.real2.spotSize = 2
        _this.echart_info_cnv.real2_umap.spotSize = 2
        _this.echart_info_cnv.real2_tsne.spotSize = 2
        _this.echart_info_cnv.real.spotSize = 2
        _this.echart_info_cnv.real_umap.spotSize = 2
        _this.echart_info_cnv.real_tsne.spotSize = 2
        _this.echart_info_cnv.cnv.spotSize = 2
        _this.echart_info_cnv.cnv_umap.spotSize = 2
        _this.echart_info_cnv.cnv_tsne.spotSize = 2
        _this.echart_info_cnv.copykat.spotSize = 2
        _this.echart_info_cnv.copykat_umap.spotSize = 2
        _this.echart_info_cnv.copykat_tsne.spotSize = 2
      }
      else {
        _this.echart_info_cnv.real1.spotSize = 4
        _this.echart_info_cnv.real1_umap.spotSize = 4
        _this.echart_info_cnv.real1_tsne.spotSize = 4
        _this.echart_info_cnv.real2.spotSize = 4
        _this.echart_info_cnv.real2_umap.spotSize = 4
        _this.echart_info_cnv.real2_tsne.spotSize = 4
        _this.echart_info_cnv.real.spotSize = 4
        _this.echart_info_cnv.cnv.spotSize = 4
        _this.echart_info_cnv.copykat.spotSize = 4
        _this.echart_info_cnv.real_umap.spotSize = 4
        _this.echart_info_cnv.cnv_umap.spotSize = 4
        _this.echart_info_cnv.copykat_umap.spotSize = 4
        _this.echart_info_cnv.real_tsne.spotSize = 4
        _this.echart_info_cnv.cnv_tsne.spotSize = 4
        _this.echart_info_cnv.copykat_tsne.spotSize = 4
      }
      for (let i=0; i< _this.echart_info_cnv.real1.types.length; i++){
        _this.echart_info_cnv.real1.tip.push({
          value: _this.echart_info_cnv.real1.types[i],
          label: _this.echart_info_cnv.real1.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real1_umap.types.length; i++){
        _this.echart_info_cnv.real1_umap.tip.push({
          value: _this.echart_info_cnv.real1_umap.types[i],
          label: _this.echart_info_cnv.real1_umap.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real1_tsne.types.length; i++){
        _this.echart_info_cnv.real1_tsne.tip.push({
          value: _this.echart_info_cnv.real1_tsne.types[i],
          label: _this.echart_info_cnv.real1_tsne.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real2.types.length; i++){
        _this.echart_info_cnv.real2.tip.push({
          value: _this.echart_info_cnv.real2.types[i],
          label: _this.echart_info_cnv.real2.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real2_umap.types.length; i++){
        _this.echart_info_cnv.real2_umap.tip.push({
          value: _this.echart_info_cnv.real2_umap.types[i],
          label: _this.echart_info_cnv.real2_umap.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real2_tsne.types.length; i++){
        _this.echart_info_cnv.real2_tsne.tip.push({
          value: _this.echart_info_cnv.real2_tsne.types[i],
          label: _this.echart_info_cnv.real2_tsne.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real.types.length; i++){
        _this.echart_info_cnv.real.tip.push({
          value: _this.echart_info_cnv.real.types[i],
          label: _this.echart_info_cnv.real.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real_umap.types.length; i++){
        _this.echart_info_cnv.real_umap.tip.push({
          value: _this.echart_info_cnv.real_umap.types[i],
          label: _this.echart_info_cnv.real_umap.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.real_tsne.types.length; i++){
        _this.echart_info_cnv.real_tsne.tip.push({
          value: _this.echart_info_cnv.real_tsne.types[i],
          label: _this.echart_info_cnv.real_tsne.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.cnv.types.length; i++){
        _this.echart_info_cnv.cnv.tip.push({
          value: _this.echart_info_cnv.cnv.types[i],
          label: _this.echart_info_cnv.cnv.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.cnv_umap.types.length; i++){
        _this.echart_info_cnv.cnv_umap.tip.push({
          value: _this.echart_info_cnv.cnv_umap.types[i],
          label: _this.echart_info_cnv.cnv_umap.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.cnv_tsne.types.length; i++){
        _this.echart_info_cnv.cnv_tsne.tip.push({
          value: _this.echart_info_cnv.cnv_tsne.types[i],
          label: _this.echart_info_cnv.cnv_tsne.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.copykat.types.length; i++){
        _this.echart_info_cnv.copykat.tip.push({
          value: _this.echart_info_cnv.copykat.types[i],
          label: _this.echart_info_cnv.copykat.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.copykat_umap.types.length; i++){
        _this.echart_info_cnv.copykat_umap.tip.push({
          value: _this.echart_info_cnv.copykat_umap.types[i],
          label: _this.echart_info_cnv.copykat_umap.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i=0; i< _this.echart_info_cnv.copykat_tsne.types.length; i++){
        _this.echart_info_cnv.copykat_tsne.tip.push({
          value: _this.echart_info_cnv.copykat_tsne.types[i],
          label: _this.echart_info_cnv.copykat_tsne.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
    },

    initLayoutData(){
      // 'Spatial Domain'
      // 'Annotation'
      // 'Fine Annotation'
      // 'InferCNV'
      // 'CopyKat'
      let index = 0
      let temp_layout = []
      let item;
      for(item in this.echart_info_cnv) {
        if (this.echart_info_cnv[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'real':
              info_pic = 'Spatial Domain';
              break;
            case 'real_umap':
              info_pic = 'Spatial Domain umap';
              break;
            case 'real_tsne':
              info_pic = 'Spatial Domain tsne';
              break;
            case 'real1':
              info_pic = 'Annotation';
              break;
            case 'real1_umap':
              info_pic = 'Annotation umap';
              break;
            case 'real1_tsne':
              info_pic = 'Annotation tsne';
              break;
            case 'real2':
              info_pic = 'Fine Annotation';
              break;
            case 'real2_umap':
              info_pic = 'Fine Annotation umap';
              break;
            case 'real2_tsne':
              info_pic = 'Fine Annotation tsne';
              break;
            case 'cnv':
              info_pic = 'InferCNV';
              break;
            case 'cnv_umap':
              info_pic = 'InferCNV umap';
              break;
            case 'cnv_tsne':
              info_pic = 'InferCNV tsne';
              break;
            case 'copykat':
              info_pic = 'CopyKat';
              break;
            case 'copykat_umap':
              info_pic = 'CopyKat umap';
              break;
            case 'copykat_tsne':
              info_pic = 'CopyKat tsne';
              break;
          }
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'CNV'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info_cnv[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      this.layoutData = temp_layout
      console.log(this.layoutData)
      this.index = index
      this.isGridShow = true
    },
  },

}
</script>

<style scoped>
#dataset_cnv{
  height: 800px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}
</style>
